export default __webpack_public_path__ + "static/media/l.c7315d67.jpg";